import { render, staticRenderFns } from "./PaymentPopup.vue?vue&type=template&id=e0afd70e&"
import script from "./PaymentPopup.vue?vue&type=script&lang=ts&"
export * from "./PaymentPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0afd70e')) {
      api.createRecord('e0afd70e', component.options)
    } else {
      api.reload('e0afd70e', component.options)
    }
    module.hot.accept("./PaymentPopup.vue?vue&type=template&id=e0afd70e&", function () {
      api.rerender('e0afd70e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/PaymentPopup.vue"
export default component.exports